<template>
    <div
        :data-component-name="$options.name"
    >
        <q-select
            ref="myInput"
            v-bind="$attrs"
            :outlined="outlined"
            :dense="dense"
            :filled="filled"
            :clearable="clearable"
            :options="menuItems"
            :multiple="multiple"
            :popup-content-class="popupContentClass"
            use-input
            @input="$emit('input', $event)"
            @filter="search"
        >
            <template v-slot:selected
                v-if="$attrs.value && $attrs.value.length"
            >
                <span v-if="$attrs.value && $attrs.value.length">
                    <span class="row inline" :key="ii" v-for="(item, ii) in $attrs.value">
                        <div>
                            {{ item.name }}
                            <UserProfileInfo :userProfile="item"
                                :forceType="forceType"
                            />
                        </div>
                        <div class="q-mr-xs" v-if="ii < $attrs.value.length - 1">,</div>
                    </span>
                </span>
            </template>

        </q-select>
    </div>
</template>

<script>
    import { LOCATIONS, LOCATIONSSEARCH/*, LOCATIONS, LOCATIONS*/ } from '@/graphql/customer/queries'
    import QSelect from 'quasar'

    export default {
        name: 'LocationInput',
        extends: QSelect,
        props: {
            variables: {
                type: Object,
                default: null
            },
            outlined: {
                type: Boolean,
                default: false
            },
            dense: {
                type: Boolean,
                default: true
            },
            filled: {
                type: Boolean,
                default: true
            },
            clearable: {
                type: Boolean,
                default: true
            },
            multiple: {
                type: Boolean,
                default: false
            },
            forceType: {
                type: String,
                default: "CustomerLocation"
            },
            popupContentClass: {
                type: String,
                default: "c-select-proxy"
            }
        },
        data(){
            return {
                searchTO: {}
            }
        },
        computed: {
            menuItems() {
                if(this.$apollo.queries.locations && !this.$apollo.queries.locations.loading) return this.locations.data
                return new Array();
            }
        },
        methods: {
            search(searchText, updatefn){
                clearTimeout(this.searchTO);
                if(searchText && searchText!=""){
                    this.searchTO=setTimeout(function(){
                        if(this.$apollo.queries.locationsSearch){
                            delete this.$apollo.queries.locationsSearch;
                        }else{
                            this.$apollo.addSmartQuery('locationsSearch', {
                                query: LOCATIONSSEARCH,
                                fetchPolicy: 'cache-first',
                                error(error){
                                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                                },
                                variables: {
                                    searchText: searchText.trim().split(" ").join("* ")+"*",
                                },
                                manual: true,
                                result ({ data }) {
                                    this.locations = Object.assign({}, data.locationsSearch);
                                    updatefn();
                                },
                            })
                        }
                    }.bind(this), 200)
                }else{
                    this.$apollo.queries.locations.refresh()
                    updatefn();
                }
            }
        },
        apollo: {
            locations: {
                query: LOCATIONS,
                fetchPolicy: 'cache-first',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(locations) {
                    locations=locations.locations;

                    setTimeout(function(){
                        this.$refs.myInput.refresh();
                    }.bind(this), 200)

                    return locations;
                },
                variables() {
                    if(this.variables) return {...this.variables}
                }
            }
        }
    }

</script>

<style lang="scss" scoped>
    .locations {
        &-wrap {
            position:relative;
        }
        &-list {
            position: absolute;
            z-index: 2;
            background: white;
            border: 1px solid gray;
            padding:6px 0;
            margin: -10px 0 0;
            list-style: none;
            // display: none;
            &-item {
                padding:6px 12px;
                &:hover {
                    background: gray;
                    color: white;
                    cursor: pointer;
                }
                &.is-hidden {
                    display:none;
                }
            }
        }
    }
</style>